import { PropsWithChildren, ReactNode } from "react"
import { Spacer } from "../../../../../components/spacer/Spacer"
import { theme } from "../../../../../styles/stitches.config"
import { SLabel } from "../../acquisitionForm/AcquisitionForm.styled"
import { Div } from "../../../../../components/div/Div"

type LabeledProps = {
  htmlFor: string
  label: ReactNode
}

export function Labeled(props: PropsWithChildren<LabeledProps>) {
  const { label, htmlFor, children } = props
  return (
    <Div>
      <SLabel htmlFor={htmlFor}>{label}</SLabel>
      <Spacer size={theme.space.s3_5} />
      {children}
    </Div>
  )
}
